// Painel: compensações à espera de aprovação (só para quem pode aprovar).
import { useApi } from "@ecliptica/api-client/react";
import { useTranslation } from "@ecliptica/i18n";
import { Card, CardContent, CardHeader, CardTitle } from "@ecliptica/ui";
import { useQuery } from "@tanstack/react-query";
import { CompensationList, type CompensationItem } from "../../features/users/Compensations";

export function PendingCompensations() {
  const { t } = useTranslation();
  const api = useApi();
  const q = useQuery({
    queryKey: ["compensations", "pending"],
    queryFn: async () => {
      const res = await api.v1.admin.compensations.$get({ query: { status: "pending_approval" } });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return (await res.json()) as CompensationItem[];
    },
  });
  return (
    <Card className="sm:col-span-2 xl:col-span-3">
      <CardHeader>
        <CardTitle>
          {t("users.comp.pendingTitle")} {q.data?.length ? `(${q.data.length})` : ""}
        </CardTitle>
      </CardHeader>
      <CardContent>{q.data?.length ? <CompensationList items={q.data} showUser /> : <p className="text-sm text-muted-foreground">{t("users.comp.pendingNone")}</p>}</CardContent>
    </Card>
  );
}
